import React,{ useState } from 'react'


export default function TextForm(props) {
    const handleUpClick = ()=>{
        // console.log("UpperCase was clicked"+text);
        let newText = text.toUpperCase(); 
        setText(newText);
        props.showAlert("Converted to UpperCase.",'success')
    }
    const handleLoClick = ()=>{
        // console.log("LowerCase was clicked"+text);
        let newText = text.toLowerCase(); 
        setText(newText);
        props.showAlert("Converted to LowerCase.",'success')
    }
    const handleRemoveCommas = ()=>{
        let newText = text.replaceAll(",","") 
        setText(newText);
        props.showAlert("Removed all commas",'success')
    }
    const handleCopy = ()=>{
        var text = document.getElementById("myBox");
        text.select();
        navigator.clipboard.writeText(text.value);
        props.showAlert("Copied to Clipboard",'success')
    }
    const handleClearText = ()=>{
        let newText = ""
        setText(newText);
        props.showAlert("Cleared all the text",'success')
    }
    const handleOnChange = (event)=>{
        // console.log("On Change");
        setText(event.target.value);
    }
    const [text, setText] = useState("");
  return (
    <>
    <div>
        <h1>{props.heading}</h1>
        <div className="mb-3">
        <textarea className="form-control" value={text} style={{backgroundColor:(props.mode==="dark")?"grey":"white",color:(props.mode==="dark")?"white":"black"}} id="myBox" rows="8" onChange={handleOnChange}></textarea>
        </div>
        <button className='btn btn-success mx-1' onClick={handleUpClick}>Convert to Uppercase</button>
        <button className='btn btn-primary mx-2' onClick={handleLoClick}>Convert to Lowercase</button>
        <button className='btn btn-info mx-2' onClick={handleCopy}>Copy Text</button>
        <button className='btn btn-warning mx-2' onClick={handleRemoveCommas}>Remove All Commas</button>
        <button className='btn btn-danger mx-2' onClick={handleClearText}>Clear All</button>
    </div>
    <div className="container my-4">
        <h2>Your Text Summary</h2>
        <p>{text.split(" ").length} words and {text.length} characters</p>
        <p>{0.008 * text.split(" ").length} minutes read</p>
        <h2>Preview</h2>
        <p>{text.length>0?text:'Enter something in the text box above to preview it here.'}</p>
    </div>
    </>
  )
}
